<template>
  <div>
    <div class="position-relative">
      <img :src="urlImgPC" class="img-fluid d-none d-sm-block animated fadeIn centered" />
      <img :src="urlImgMO" class="img-mobile img-fluid d-block d-sm-none animated fadeIn centered" />
      <div class="contador d-flex flex-row">
        <div class="countdown">
          <div class="block">
            <p class="digit">{{ days | two_digits }}</p>
            <p class="text">Días</p>
          </div>
          <div class="block">
            <p class="digit">{{ hours | two_digits }}</p>
            <p class="text">Horas</p>
          </div>
          <div class="block">
            <p class="digit">{{ minutes | two_digits }}</p>
            <p class="text">Minutos</p>
          </div>
          <!-- <div class="block">
            <p class="digit">{{ seconds | two_digits }}</p>
            <p class="text">Seg</p>
          </div> -->
        </div>
        <div class="botones d-flex flex-column">
          <button class="boton-blanco" @click="$parent.getCalendarEvent();">AGENDAR</button>
          <!-- <button class="boton-blanco" @click="$parent.startFCM();">SUSCRÍBETE</button> -->
        </div>
      </div>
    </div>

    <div class="modal-video" v-if="showmodal">
      <div class="modal-content">
        <div class="btncerrar" role="button" @click="closeModal">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
          </svg>
        </div>
        <iframe :src="`https://www.youtube-nocookie.com/embed/${modalid}`" title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import Tips from "@/components/Tips";
import Programas from "@/components/Programas";
import OfferCards from "@/components/OfferCards";
import VueSlickCarousel from "vue-slick-carousel";

export default {
  name: "PreLiveShop",
  props: ['date', 'urlImgPC', 'urlImgMO'],
  components: { Tips, Programas, OfferCards, VueSlickCarousel },
  data() {
    return {
      showmodal: false,
      modalid: '',
      now: Math.trunc(new Date().getTime() / 1000),
    }
  },
  methods: {
    displayModal(id) {
      this.modalid = id
      this.showmodal = true
    },
    closeModal() {
      this.showmodal = false
      this.modalid = ''
    },
    intervalTest() {
      this.interval = setInterval(() => {
        this.now = Math.trunc(new Date().getTime() / 1000);
        if (this.now >= this.dateInMilliseconds) {
          clearInterval(this.interval);
        }
        //console.log(this.seconds);
      }, 1000)
    }
  },
  computed: {
    dateInMilliseconds() {
      return Math.trunc(Date.parse(this.date) / 1000);
    },
    seconds() {
      return (this.dateInMilliseconds - this.now) % 60;
    },
    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
    },
    hours() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
    },
    days() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
    },
  },
  mounted() {
    this.intervalTest();
  }
}
</script>
<style lang="scss" scoped>
#videoteaser {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}

#videoteaser iframe,
#videoteaser object,
#videoteaser embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.img-placeholder {
  visibility: hidden;
}

.specs {
  background-image: url('/img/pre/360-banner-pc.jpg');
  background-size: cover;

  @media (max-width: 480px) {
    background-image: url('/img/pre/360-banner-mo.jpg');
    padding-right: 15px !important;
    padding-left: 15px !important;
  }

  .content {
    top: 0;
    left: 0;

    @media (max-width: 480px) {
      left: auto;
      text-align: center;

      h1 {
        font-size: 1.5em !important;
      }

      strong {
        line-height: 1.2;

        @media (max-width: 480px) {
          font-size: 13px;
        }
      }
    }

    strong {
      font-size: 11px;
    }

    h1 {
      margin-bottom: 0;
    }
  }
}

small {
  display: block;

  @media (max-width: 480px) {
    display: none;
  }
}

.icons {
  text-align: center;

  .item-icon {
    border-right: 1px solid #ddd;
    padding: 0;

    img {
      width: 50px;
      margin: 1em;
    }

    p {
      font-weight: 600;
      font-size: 12px;
    }

    &:last-child {
      border: 0;
    }

    @media(max-width: 480px) {
      margin-bottom: 1em;
      border: 0;
    }
  }

}

.botones {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;

  @media only screen and (max-width: 480px) {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}

.boton-blanco {
  margin: 0 20px;
  color: #000;
  border-radius: 10px;
  padding: 5px 30px;
  border: 0;
  transition: background-color 250ms linear;
  font-size: 14px;
  text-transform: uppercase;
  background-color: #ffffff;
  font-weight: bold;

  &:first-child {
    margin-bottom: 10px;
  }

  &:hover {
    background-color: #555;
    color: #fff;
  }

  @media only screen and (max-width: 480px) {
    font-size: 14px;
    padding: 5px 15px;
    margin: 0 10px;

    &:first-child {
      margin-bottom: 5px;
    }
  }

  @media only screen and (max-width: 282px) {
    font-size: 12px;
    padding: 5px 5px;
    margin: 0 8px;
  }
}

.pre-title {
  color: #000;
  margin: 0;
  padding: 10px;

  @media only screen and (max-width: 480px) {
    font-size: 14px;
    padding: 5px;
  }
}

.img-mobile {
  @media only screen and (max-width: 480px) {
    max-width: 100%;
    max-height: 650px;
    margin: 0 auto;
    display: table;
  }
}

.contador {
  position: absolute;
  overflow: hidden;
  bottom: 5%;
  width: 44%;
  left: 9%;
  border-radius: 25px;
  z-index: 8;
  background-color: rgba(0, 0, 0, 0.5);

  @media only screen and (max-width: 480px) {
    bottom: 7%;
    left: 50%;
    width: 80%;
    transform: translateX(-50%);

    p.desktop {
      display: none;
    }
  }

  @media only screen and (max-width: 430px) {
    width: 88%;
  }

  @media only screen and (max-width: 375px) {
    width: 95%;
  }
}

.boton-suscripcion {
  background-color: white !important;
  border-radius: 5px !important;

  @media only screen and (max-width: 480px) {
    font-size: 12px !important;
    padding: 4px 5px !important;
  }
}

.btn-negro {
  background-color: black !important;
  border-radius: 20px !important;
  color: white !important;
  padding: 5px 25px !important;

  @media only screen and (max-width: 480px) {
    font-size: 12px !important;
  }
}

.btn-borde {
  background-color: white !important;
  border-radius: 10px !important;
  color: black !important;
  padding: 8px 25px !important;
  border: black 1px solid;
  font-size: 12px;
  font-weight: bold;
  transition: background-color 250ms linear;

  &:hover {
    background-color: black !important;
    color: white !important;
    text-decoration: none;
  }

  @media only screen and (max-width: 480px) {
    font-size: 12px !important;
  }
}

.s01-up {
  margin-top: 130px;

  @media only screen and (max-width: 480px) {
    margin-top: 100px;

    img {
      width: 45px;
      margin-bottom: 10px;
    }

    h1 {
      width: 80%;
      margin: 0 auto;
    }

    p {
      width: 80%;
      margin: 10px auto;
    }
  }
}

.s01-section {
  padding: 40px 0;

  @media only screen and (max-width: 480px) {
    padding: 20px 0;
  }
}

.countdown {
  display: flex;
  width: 70%;
  margin: auto;
  color: white;

  &.blanco {
    color: #fff;
    text-shadow: 1px 1px 1px #222;
  }

  @media only screen and (max-width: 480px) {
    width: 100%;
    padding-top: 10px;
  }
}

.block {
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  width: 33%;
  align-items: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 8px;
    right: -5px;
    width: 1px;
    height: 75px;
    display: block;
    border-right: solid 1px #ffffff;

    @media only screen and (max-width: 480px) {
      font-size: 3em;
      top: 0px;
      height: 60px;
    }
  }

  /* &:nth-child(3n)::after{
    display: none;
  } */
  /* &:last-child{
    border-right: none;
    display: none;
  } */
  @media only screen and (max-width: 480px) {
    margin: 0;
  }
}

.text {
  font-size: 0.7rem;
  text-align: center;
  margin: 5px;
  margin-top: 0;
  text-transform: uppercase;
}

.digit {
  text-align: center;
  font-size: 4em;
  font-weight: bold;
  line-height: 1;
  margin: 5px;

  @media only screen and (max-width: 480px) {
    font-size: 2.8em;
    margin-bottom: 0px;
    margin-top: 0;
  }

  @media only screen and (max-width: 282px) {
    font-size: 2.2em;
  }
}

.modal-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .6);
  display: flex;
  z-index: 9;

  .btncerrar {
    display: block;
    width: 24px;
    height: 24px;
    background: white;
    border-radius: 50%;
    padding: 0;
    position: absolute;
    right: -10px;
    top: -10px;
  }

  .modal-content {
    background: transparent;
    margin: auto;
    aspect-ratio: 16/9;
    position: relative;
    width: 70%;

    @media only screen and (max-width: 480px) {
      margin: 20% auto;
      width: 92%;
    }

    iframe {
      width: 100%;
      aspect-ratio: 16/9;
    }
  }
}
</style>